import type { FaireProductEntity } from "../../entity_types/product";

export const p_mghzxnawfg: FaireProductEntity = {
  token: "p_mghzxnawfg",
  type: "product",
  name: "Croissant Baseball Cap/Dad Hat",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/251890a3c9cbe336adb32b12af73ba0bd1e9abe57d05475dd3c6a8cad27d00d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7a7d8514fe63453c7bb5d20f277e5cccd666957f86664a071143714de5548482.jpeg"
  ],
  priceDollars: 17.5,
  description: "Rise and shine in style with the Croissant Hat. Crafted for comfort and flair, this soft, adjustable hat features an embroidered croissant icon that foodies will adore. Whether you’re running errands, meeting friends for coffee (and a pastry), or just want a playful treat to brighten your day, this hat is a perfect accessory. \n\nMakes a great gift for bakers, brunch lovers, or anyone who loves food-inspired designs.\n\nGood to know:\n\n * Ochre hat with embroidered illustrated croissant design \n * Features adjustable back buckle ",
  tags: [],
  msrpDollars: 35,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:06.972Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
